export const mainLogo = {
    src: "/logo.png",
    alt: `${import.meta.env.VITE_PROJECT_NAME} Logo`
}

export const projectName = import.meta.env.VITE_PROJECT_NAME || "Frontend"

export const sampleProductImage = "https://storage.googleapis.com/qolca-basic-santiago/products/products.jpg"
export const sampleCategoryImage = "https://storage.googleapis.com/qolca-basic-santiago/categories/categories.jpg"